import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  /**
   * constructor
   * @param http 
   * @param environment 
   * @param datePipe 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService,
    private datePipe: DatePipe) {

  }
  /**
   * Get the List of all ExportJobs
   * @returns 
   */
  getExportJobs(): Observable<any[]> {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get<any[]>(`${url}/admin/integration/export/job`)
      )
    )
  }
  /**
   * Get the FIle to an ExportJob
   * @returns 
   */
  getExportJobHistory(): Observable<any[]> {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get<any[]>(`${url}/admin/integration/export/job/file`)
      )
    )
  }
  /**
   * Download an ExportJob
   * @param name 
   */
  downloadExport(name) {
    const encoded = encodeURIComponent(name);
    this.http.get<any[]>(`${this.environment.getApiUrl()}/admin/integration/export/job/get?jobName=${encoded}`)
      .subscribe((response: any) => {
        console.log(response)
        const url = URL.createObjectURL(response.body);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = name;
        anchor.click();
        URL.revokeObjectURL(url);
      });
  }
  /**
   * Start the Job to create an ExportJob
   * @param jobType 
   * @returns 
   */
  startExport(jobType) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/admin/integration/export/job/start/${jobType}?jobName=${jobType}`, {})
      )
    )
  }
  /**
   * Search a Batch Status paginated
   * @param page 
   * @param size 
   * @returns 
   */
  getBatchStatus(page, size): Observable<any> {
    return this.http.get(`${this.environment.getApiUrl()}/admin/integration/processed?page=${page}&size=${size}`)
  }
  /**
   * Upload a File to import the Garbagedata
   * @param file 
   * @returns 
   */
  uploadGarbageFile(file): Observable<any[]> {
    let data: FormData = new FormData();
    data.append('file', file);
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post<any[]>(`${url}/garbagepickup/csv`, data).pipe(
        map(res => {
          for (let item of res) {
            item.street = item['streets'][0].name;
            item.date = this.datePipe.transform(item.date, 'dd.MM.yyyy');
          }
          return res;
        })
      )
      )
    )
  }
  /**
   * Start the Import of the Garbagedata
   * @returns 
   */
  startGarbageImport() {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/garbagepickup/csv/accept`, {})
      )
    )
  }
  /**
   * Download a Batchfile
   * @param filepath 
   */
  downloadBatchFile(filepath) {
    const encoded = encodeURIComponent(filepath);
    this.http.get<any[]>(`${this.environment.getUrl()}/${this.environment.getClientId()}/admin/integration/import/job/get?jobName=${encoded}`, { responseType: 'blob' as any, observe: 'response' })
      .subscribe((response: any) => {
        const url = URL.createObjectURL(response.body);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
}
